<template>
  <v-container>
    <v-card class="pa-1 ma-1 pb-1 rounded-lg" elevation="15">
      <v-card-title>QR scanner</v-card-title>
      <v-spacer class="mt-5"></v-spacer>
      <v-card-text>
        <v-row justify="start">
          <v-col md="2" cols="2">
            <v-btn
              text="เพิ่มด้วย QRcode"
              color="pink-darken-1"
              class="ma-2 font-weight-bold"
              @click="
                (qr_diaglog = !qr_diaglog),
                  (foundUser = false),
                  (csvdialog = false)
              "
              :disabled="sh_numbtn"
              active-color="blue-darken-2"
            ></v-btn>
          </v-col>

          <!-- <v-col md="1" cols="1">
            <v-btn
              text="ค้นหาด้วยรหัส"
              color="pink-darken-1"
              class="ma-2"
              active-color="blue-darken-2"
              @click="(sh_numbtn = !sh_numbtn), (foundUser = false)"
              :active="sh_numbtn"
            ></v-btn>
          </v-col>
          <v-col md="4" cols="2" style="min-height: 110px">
            <v-scale-transition>
              <v-text-field
                :disabled="!sh_numbtn"
                label="รหัสนักศึกษา"
                variant="outlined"
                class="font-weight-bold"
                base-color="blue-darken-2"
                color="blue-darken-2"
                v-model="reqStudentNum"
                :hint="errorMessage"
                :persistent-hint="errorMessage"
              ></v-text-field>
            </v-scale-transition>
          </v-col> -->
          <!-- <v-col md="1" cols="1" style="min-height: 110px">
            <v-scale-transition>
              <v-btn
                v-show="sh_numbtn"
                text="ค้นหา"
                color="blue-darken-2"
                class="ma-2"
                @click="handleSearch()"
              ></v-btn>
            </v-scale-transition>
          </v-col> -->
          <v-col md="2" cols="2" style="min-height: 110px">
            <v-scale-transition>
              <v-btn
                text="Upload CSV"
                color="blue-darken-2"
                class="ma-2 font-weight-bold"
                @click="csvdialog = !csvdialog"
              ></v-btn>
            </v-scale-transition>
          </v-col>
          <!-- <v-col md="2" cols="2" style="min-height: 110px">
            <v-scale-transition>
              <v-btn
                text="add plo with QR "
                color="blue-darken-2"
                class="ma-2"
                @click="plodialog = !plodialog"
              ></v-btn>
            </v-scale-transition>
          </v-col> -->
        </v-row>
        <v-spacer class="mt-0"></v-spacer>
      </v-card-text>
    </v-card>

    <v-dialog
      v-model="qr_diaglog"
      width="70%"
      max-width="700"
      class="py-2"
      transition="slide-y-transition"
      persistent
    >
      <v-card
        max-width="700"
        prepend-icon="mdi-account-plus"
        rounded="lg"
        class="elevation-10 mb-5 p-0"
      >
        <v-card class="mx-auto" max-width="700">
          <v-card-title class="headline text-center">
            <v-icon left>mdi-qrcode-scan</v-icon>
            QRcode scanner
          </v-card-title>

          <v-card-text>
            <!-- Error Alert -->
            <v-alert
              v-if="errorMessage"
              type="error"
              dismissible
              @input="errorMessage = ''"
              class="mb-4"
            >
              {{ errorMessage }}
              <template v-if="showPermissionHelp">
                <br /><br />
                <strong>To fix this:</strong>
                <ul>
                  <li>Look for a camera icon in your browser's address bar</li>
                  <li>Click it and select "Allow"</li>
                  <li>Refresh this page</li>
                  <li>Make sure you're using HTTPS (not HTTP)</li>
                </ul>
              </template>
            </v-alert>

            <!-- Loading State -->
            <div v-if="isLoading" class="text-center pa-4">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
              <p class="mt-2">Requesting camera access...</p>
            </div>

            <div class="video-container">
              <video
                v-show="!errorMessage && !isLoading"
                ref="videoRef"
                autoplay
                playsinline
                muted
                :class="['qr-scanner-video', videoRotationClass]"
              ></video>
            </div>
            <!-- Video Element -->

            <!-- QR Data Display -->
            <div v-if="qrData" class="mt-4">
              <v-alert type="success" class="mb-2">
                <strong>QR Code Detected!</strong>
                <span v-if="qrData.type">Type: {{ qrData.type }}</span>
              </v-alert>
            </div>

            <!-- Multiple Input Fields for Different Data -->

            <!-- Manual Input Fallback -->
            <!-- <v-text-field
              v-if="showManualInput"
              v-model="manualInput"
              label="Or enter student number manually"
              prepend-icon="mdi-keyboard"
              outlined
              clearable
              class="mt-2"
              @keyup.enter="useManualInput"
            ></v-text-field> -->
          </v-card-text>

          <v-card-actions>
            <v-btn
              v-if="errorMessage"
              block
              color="secondary"
              @click="retryCamera"
            >
              <v-icon left>mdi-refresh</v-icon>
              Try Again
            </v-btn>

            <!-- <v-btn
              v-if="errorMessage && !showManualInput"
              block
              color="info"
              @click="showManualInput = true"
              class="mt-2"
            >
              <v-icon left>mdi-keyboard</v-icon>
              Enter Manually Instead
            </v-btn> -->

            <!-- <v-btn
              v-if="qrData"
              block
              color="warning"
              @click="clearData"
              class="mt-2"
            >
              <v-icon left>mdi-refresh</v-icon>
              Scan Another QR Code
            </v-btn> -->
          </v-card-actions>
        </v-card>

        <template v-slot:actions>
          <!-- <v-btn
            class="mb-3 mr-3"
            variant="elevated"
            elevation="3"
            color="green"
            text="ลงทะเบียน"
          ></v-btn> -->
          <v-btn
            class="mb-3 mr-3"
            variant="elevated"
            elevation="3"
            color="red"
            text="ปิด"
            @click="qr_diaglog = false"
          ></v-btn>
        </template>
      </v-card>
    </v-dialog>

    <v-fade-transition>
      <v-card
        v-if="foundUser"
        class="pa-1 ma-1 pb-1 mt-5 rounded-lg"
        elevation="15"
      >
        <v-card-title>ข้อมูลนักศึกษา</v-card-title>
        <v-spacer class="mt-5"></v-spacer>
        <v-card-text>
          <v-row justify="start">
            <v-col md="4" cols="4">
              <v-text-field
                v-model="studentNumber"
                label="รหัสนักศึกษา"
                prepend-icon="mdi-account"
                variant="outlined"
                clearable
                readonly
              ></v-text-field>
            </v-col>

            <v-col md="4" cols="4">
              <v-text-field
                v-model="studentName"
                label="ชื่อ-นามสกุล"
                prepend-icon="mdi-account-circle"
                variant="outlined"
                clearable
                readonly
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row justify="start" cols="12">
            <v-col md="2" cols="2" class="ms-5">
              <v-radio-group v-model="subjectPrefix">
                <v-radio label="รหัส 1" value="1"></v-radio>
                <v-radio label="รหัส 2" value="2"></v-radio>
                <v-radio label="รหัส 3" value="3"></v-radio>
                <v-radio label="รหัส 4" value="4"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col md="3" align-self="center">
              <v-select
                prepend-icon="mdi-book-open-variant"
                class=""
                label="วิชา"
                :items="filteredSubjects"
                item-title="Subject_Id"
                item-value="Subject_Id"
                v-model="subject"
                variant="outlined"
                required
              >
                <template #item="{ props, item }">
                  <v-list-item
                    v-bind="props"
                    :title="item.raw.Subject_Id"
                    :subtitle="item.raw.Subject_Name"
                  ></v-list-item>
                </template>

                <template #selection="{ item }">
                  <div class="d-flex flex-column">
                    <span>{{ item.raw.Subject_Id }}</span>
                    <span class="text-caption text-medium-emphasis">{{
                      item.raw.Subject_Name
                    }}</span>
                  </div>
                </template>
              </v-select>
            </v-col>

            <v-col md="2" align-self="center">
              <v-select
                prepend-icon="mdi-book-open-variant"
                class=""
                label="ภาคเรียน"
                v-model="semester_0"
                :items="['Midterm', 'Final']"
                variant="outlined"
                required
              ></v-select>
              <v-select
                prepend-icon="mdi-book-open-variant"
                class=""
                label="ภาคเรียน"
                v-model="semester_1"
                :items="[' 1', '2', '3']"
                variant="outlined"
                required
              ></v-select>
            </v-col>
            <v-col md="2" align-self="center">
              <v-select
                prepend-icon="mdi-book-open-variant"
                class=""
                label="ปีการศึกษา"
                v-model="semester_2"
                :items="[
                  '2567',
                  '2568',
                  '2569',
                  '2570',
                  '2571',
                  '2572',
                  '2573',
                  '2574',
                  '2575',
                ]"
                variant="outlined"
                required
              ></v-select>
            </v-col>
            <v-col md="2" align-self="center">
              <v-text-field
                v-model="score"
                label="คะแนน"
                prepend-icon="mdi-calendar"
                variant="outlined"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-spacer class="mt-0"></v-spacer>
        </v-card-text>
        <template v-slot:actions>
          <v-row justify="start">
            <v-col cols="1" md="1">
              <v-btn
                class="mb-3 font-weight-bold"
                variant="elevated"
                elevation="7"
                color="red-darken-1"
                text="ล้างข้อมูล"
                @click="clearData"
              ></v-btn>
            </v-col>
            <v-col cols="1" md="1">
              <v-btn
                class="mb-3 font-weight-bold"
                variant="elevated"
                elevation="7"
                color="green-darken-1"
                text="Submit"
                @click="handleUpdate()"
              ></v-btn>
            </v-col>
          </v-row>
        </template>
      </v-card>

      <v-card
        v-if="csvdialog"
        class="pa-1 ma-1 pb-1 mt-5 rounded-lg"
        elevation="15"
      >
        <v-card-title>Import CSV</v-card-title>
        <v-spacer class="mt-5"></v-spacer>
        <v-card-text>
          <v-row justify="start" cols="12">
            <v-col md="1" cols="1" class="ms-5">
              <v-radio-group v-model="subjectPrefix">
                <v-radio label="รหัส 1" value="1"></v-radio>
                <v-radio label="รหัส 2" value="2"></v-radio>
                <v-radio label="รหัส 3" value="3"></v-radio>
                <v-radio label="รหัส 4" value="4"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col md="3" align-self="center">
              <v-select
                prepend-icon="mdi-book-open-variant"
                class="ms-n5"
                label="วิชา"
                :items="filteredSubjects"
                item-title="Subject_Id"
                item-value="Subject_Id"
                v-model="subject"
                variant="outlined"
                required
              >
                <template #item="{ props, item }">
                  <v-list-item
                    v-bind="props"
                    :title="item.raw.Subject_Id"
                    :subtitle="item.raw.Subject_Name"
                  ></v-list-item>
                </template>

                <template #selection="{ item }">
                  <div class="d-flex flex-column">
                    <span>{{ item.raw.Subject_Id }}</span>
                    <span class="text-caption text-medium-emphasis">{{
                      item.raw.Subject_Name
                    }}</span>
                  </div>
                </template>
              </v-select>
            </v-col>

            <v-col md="2" align-self="center">
              <v-select
                prepend-icon="mdi-book-open-variant"
                class=""
                label="ภาคเรียน"
                v-model="semester_0"
                :items="['Midterm', 'Final']"
                variant="outlined"
                required
              ></v-select>
              <v-select
                prepend-icon="mdi-book-open-variant"
                class=""
                label="ภาคเรียน"
                v-model="semester_1"
                :items="[' 1', '2', '3']"
                variant="outlined"
                required
              ></v-select>
            </v-col>
            <v-col md="2" align-self="center">
              <v-select
                prepend-icon="mdi-book-open-variant"
                class=""
                label="ปีการศึกษา"
                v-model="semester_2"
                :items="[
                  '2567',
                  '2568',
                  '2569',
                  '2570',
                  '2571',
                  '2572',
                  '2573',
                  '2574',
                  '2575',
                ]"
                variant="outlined"
                required
              ></v-select>
            </v-col>
          </v-row>
          <v-spacer class="mt-0"></v-spacer>
        </v-card-text>
        <template v-slot:actions>
          <v-row justify="start">
            <v-col cols="1" md="1">
              <v-btn
                class="mb-3 font-weight-bold"
                variant="elevated"
                elevation="7"
                color="red-darken-1"
                text="ล้างข้อมูล"
                @click="clearData"
              ></v-btn>
            </v-col>
            <v-col cols="1" md="1">
              <v-btn
                class="mb-3 font-weight-bold"
                variant="elevated"
                elevation="7"
                color="green-darken-1"
                text="Next"
                @click="confirmcsv = !confirmcsv"
                :disabled="subject && !semester_0 && !semester_1 && !semester_2"
              ></v-btn>
            </v-col>
          </v-row>
        </template>
      </v-card>

      <v-card
        v-if="plodialog"
        class="pa-1 ma-1 pb-1 mt-5 rounded-lg"
        elevation="15"
      >
        <v-card-title>ADD PLO</v-card-title>
        <v-spacer class="mt-5"></v-spacer>
        <v-card-text>
          <v-row justify="start" cols="12">
            <v-col md="4" align-self="center" min-width="200">
              <v-select
                prepend-icon="mdi-book-open-variant"
                class="ms-5"
                label="ตัวชี้วัด"
                :items="PLO_option"
                item-title="name"
                item-value="id"
                v-model="selectedPLO"
                variant="outlined"
                required
              >
              </v-select>
            </v-col>

            <v-col md="2" align-self="center">
              <v-select
                prepend-icon="mdi-book-open-variant"
                class=""
                label="ภาคเรียน"
                v-model="semester_0"
                :items="['Midterm', 'Final']"
                variant="outlined"
                required
              ></v-select>
              <v-select
                prepend-icon="mdi-book-open-variant"
                class=""
                label="ภาคเรียน"
                v-model="semester_1"
                :items="[' 1', '2', '3']"
                variant="outlined"
                required
              ></v-select>
            </v-col>
            <v-col md="2" align-self="center">
              <v-select
                prepend-icon="mdi-book-open-variant"
                class=""
                label="ปีการศึกษา"
                v-model="semester_2"
                :items="[
                  '2567',
                  '2568',
                  '2569',
                  '2570',
                  '2571',
                  '2572',
                  '2573',
                  '2574',
                  '2575',
                ]"
                variant="outlined"
                required
              ></v-select>
            </v-col>
          </v-row>
          <v-spacer class="mt-0"></v-spacer>
        </v-card-text>
        <template v-slot:actions>
          <v-row justify="start">
            <v-col cols="1" md="1">
              <v-btn
                class="mb-3 font-weight-bold"
                variant="elevated"
                elevation="7"
                color="red-darken-1"
                text="ล้างข้อมูล"
                @click="clearData"
              ></v-btn>
            </v-col>
            <v-col cols="1" md="1">
              <v-btn
                class="mb-3 font-weight-bold"
                variant="elevated"
                elevation="7"
                color="green-darken-1"
                text="Next"
                @click="confirmcsv = !confirmcsv"
                :disabled="subject && !semester_0 && !semester_1 && !semester_2"
              ></v-btn>
            </v-col>
          </v-row>
        </template>
      </v-card>
    </v-fade-transition>

    <v-dialog
      v-model="confirmcsv"
      width="70%"
      max-width="700"
      class="py-2"
      transition="slide-y-transition"
      persistent
    >
      <v-card
        max-width="700"
        prepend-icon="mdi-account-plus"
        rounded="lg"
        class="elevation-10 mb-5 p-0"
      >
        <v-card-text>
          <v-row cols="12" justify="center" class="mb-4">
            <v-icon color="blue-darken-2" size="48">mdi-file-upload</v-icon>
            <span class="text-h6 font-weight-bold ms-3"
              >{{ subject }} - {{ conCatSemester }}</span
            >
            <v-col md="12" cols="12" class="mt-2">
              <v-file-input
                variant="outlined"
                v-model="file"
                label="Select CSV File"
                hint="กรุณาตรวจสอบวิชาให้ถูกต้องก่อนอัพโหลด !!!"
                accept=".csv"
                outlined
                dense
                prepend-icon="mdi-file-upload"
                hint-color="red"
              ></v-file-input>
              <!-- <v-file-upload
                density="compact"
                variant="compact"
                v-model="file"
                accept=".csv"
              >
              </v-file-upload> -->
            </v-col>
          </v-row>
        </v-card-text>

        <template v-slot:actions>
          <v-btn
            class="mb-3 mr-3"
            variant="elevated"
            elevation="3"
            color="green"
            text="Upload"
            @click="fileupload"
            :disabled="!file"
          ></v-btn>
          <v-btn
            class="mb-3 mr-3"
            variant="elevated"
            elevation="3"
            color="red"
            text="ปิด"
            @click="confirmcsv = false"
          ></v-btn>
        </template>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script setup>
import { useAuthStore } from "@/stores/auth";
import {
  ref,
  onMounted,
  computed,
  onUnmounted,
  watch,
  nextTick,
  reactive,
} from "vue";
const { proxy } = getCurrentInstance();
import { getCurrentInstance } from "vue";
import router from "@/router";
import axios from "axios";
import jsQR from "jsqr";
const plodialog = ref(false);
const authStore = useAuthStore();
const TOKEN = authStore.getBackendJwt();
// QR-CODE
import QRCode from "qrcode";
const API_BASE_URL = process.env.VUE_APP_BACKEND_BASE_URL;
const subjectOptions = ref([]);
const subject = ref("");
// const subjectOptions = reactive([
//   "วิชา 1",
//   "วิชา 2",
//   "วิชา 3"
// ]);
const score = ref(0);
//Semester Options
const semester_0 = ref("Midterm");
const semester_1 = ref("1");
const semester_2 = ref(new Date().getFullYear() + 543 - 1);
const subjectPrefix = ref("1");
const conCatSemester =
  computed(() => {
    return (
      semester_0.value.toLowerCase() +
      " " +
      semester_1.value.trim() +
      "/" +
      semester_2.value
    );
  }) || "None";
//Semester Options

const sh_numbtn = ref(false);
const qr_diaglog = ref(false);
const foundUser = ref(false);
const csvdialog = ref(false);
const videoRef = ref(null);

// user INFO
const studentNumber = ref("");
const studentName = ref("");
// user INFO

const rawQRData = ref("");
const qrData = ref(null);
const manualInput = ref("");
const stream = ref(null);
const errorMessage = ref("");
const isLoading = ref(false);
const showPermissionHelp = ref(false);
const showManualInput = ref(false);
const reqStudentNum = ref("");
const confirmcsv = ref(false);

//PLO
const selectedPLO = ref("");
const PLO_option = ref([
  { id: "PLO1", name: "PLO 1 Volunteer activity" },
  { id: "PLO2", name: "PLO 2 Ethic skill" },
  { id: "PLO3", name: "PLO 3 Innovative & res" },
  { id: "PLO4", name: "PLO 4 Critical skill" },
  { id: "PLO5", name: "PLO 5 Life-Long Learning" },
  { id: "PLO6", name: "PLO 6 Leadership skill" },
  { id: "PLO7", name: "PLO 7 Commute & IT skill" },
  { id: "PLO8", name: "PLO 8 OSCE " },
]);

const handleSearch = async () => {
  csvdialog.value = false;
  isLoading.value = true;
  errorMessage.value = "";
  try {
    const studentNumTrimmed = reqStudentNum.value.trim();
    if (!studentNumTrimmed) {
      errorMessage.value = "Please enter a student number.";
      isLoading.value = false;
      return;
    }
    const response = await axios.get(`/api/getStudent/${studentNumTrimmed}`, {
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        "Content-Type": "application/json",
      },
      validateStatus: function (status) {
        return (
          (status >= 200 && status < 300) ||
          status === 400 ||
          status === 404 ||
          status === 401
        );
      },
    });
    if (response.status === 200) {
      const student = response.data.student;
      studentNumber.value = student.studentNum || "";
      studentName.value = student.displayName || "";
      foundUser.value = true;
      isLoading.value = false;
    } else if (response.status === 404) {
      errorMessage.value = "ไม่พบรหัสนักศึกษานี้.";
      isLoading.value = false;
      foundUser.value = false;
    } else if (response.status === 401 || response.status === 403) {
      isLoading.value = false;
      router.push("/");
    } else {
      errorMessage.value = "An unexpected error occurred.";
      isLoading.value = false;
    }
  } catch (err) {
    console.log("error", err);
    console.log(reqStudentNum.value);
    errorMessage.value = "Network error. Please try again.";
    isLoading.value = false;
  }
};

const handleUpdate = async () => {
  isLoading.value = true;
  errorMessage.value = "";
  try {
    const update = {
      reqstudentNum: studentNumber.value.trim(),
      reqsemester: conCatSemester.value,
      reqsubject: subject.value,
      reqscore: score.value,
    };

    if ((!update.reqstudentNum, !update.reqsemester)) {
      errorMessage.value = "Please enter a student or semester.";
      isLoading.value = false;
      console.log("error no data");
      return;
    }
    const response = await axios.patch(`/api/update`, update, {
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        "Content-Type": "application/json",
      },
      validateStatus: function (status) {
        return (
          (status >= 200 && status < 300) ||
          status === 400 ||
          status === 404 ||
          status === 401
        );
      },
    });
    if (response.status === 200) {
      isLoading.value = false;
      await proxy.$swal({
        title: "Successful!",
        text: "เรียบร้อย!! ",
        icon: "success",
        timer: 1000,
      });
    }
  } catch (err) {
    console.log("error", err);
    console.log(reqStudentNum.value);
    errorMessage.value = "Network error. Please try again.";
    isLoading.value = false;
  }
};

let intervalId = null;

// Clear all data fields
const clearData = () => {
  studentNumber.value = "";
  studentName.value = "";

  rawQRData.value = "";
  qrData.value = null;
  subject.value = "";

  // Restart scanning
  if (!errorMessage.value && stream.value) {
    intervalId = setInterval(tick, 100);
  }
};

// Parse QR code data
const parseQRData = (data) => {
  console.log("Raw QR Data:", data);
  rawQRData.value = data;

  try {
    // Try to parse as JSON
    const trimData = data.trim();
    const parsedData = JSON.parse(trimData);
    console.log("Parsed QR Object:", parsedData);

    qrData.value = parsedData;

    // Populate fields based on the object structure
    // Handle different possible property names
    studentNumber.value = parsedData.studentNum || "";

    studentName.value = parsedData.displayName || "";

    // Log what we found
    console.log("Extracted Data:", {
      studentNumber: studentNumber.value,
      studentName: studentName.value,
    });
    qr_diaglog.value = false;
    foundUser.value = true;
    qrData.value = null;
  } catch (error) {
    // If not JSON, treat as simple string (probably just student number)
    console.log("Not JSON, treating as student number:", data);
    studentNumber.value = data;
    qrData.value = { studentNumber: data, type: "simple" };
  }
};

// The scanning function
const tick = () => {
  if (
    videoRef.value &&
    videoRef.value.readyState === videoRef.value.HAVE_ENOUGH_DATA
  ) {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    canvas.height = videoRef.value.videoHeight;
    canvas.width = videoRef.value.videoWidth;
    context.drawImage(videoRef.value, 0, 0, canvas.width, canvas.height);

    const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
    const code = jsQR(imageData.data, imageData.width, imageData.height);

    if (code) {
      parseQRData(code.data);
      stopCamera(); // Stop the scanner
      console.log("Scanned QR data:", code.data);
    }
  }
};

// Initialize camera with better error handling
const initCamera = async () => {
  isLoading.value = true;
  errorMessage.value = "";
  showPermissionHelp.value = false;

  try {
    // First, check if getUserMedia is supported
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      throw new Error("Camera API not supported in this browser");
    }

    // Request camera access
    const mediaStream = await navigator.mediaDevices.getUserMedia({
      video: {
        facingMode: "environment", // Use back camera on mobile
        width: { ideal: 640 },
        height: { ideal: 480 },
      },
    });

    stream.value = mediaStream;

    // Wait for video element to be ready
    await nextTick();
    if (videoRef.value) {
      console.log("media set");
      videoRef.value.srcObject = mediaStream;

      // Wait for video to load
      await new Promise((resolve) => {
        videoRef.value.onloadedmetadata = resolve;
      });
      setVideoOrientation();
      intervalId = setInterval(tick, 100); // Start scanning every 100ms
      isLoading.value = false;
    }
  } catch (err) {
    isLoading.value = false;
    console.error("Error accessing the camera: ", err);

    // Provide specific error messages
    if (
      err.name === "NotAllowedError" ||
      err.name === "PermissionDeniedError"
    ) {
      errorMessage.value =
        "Camera access denied. Please allow camera permissions and try again.";
      showPermissionHelp.value = true;
    } else if (
      err.name === "NotFoundError" ||
      err.name === "DevicesNotFoundError"
    ) {
      errorMessage.value = "No camera found on this device.";
    } else if (err.name === "NotSupportedError") {
      errorMessage.value =
        "Camera not supported in this browser. Try using Chrome, Firefox, or Safari.";
    } else if (err.name === "NotReadableError") {
      errorMessage.value =
        "Camera is already in use by another application. Please close other camera apps and try again.";
    } else {
      errorMessage.value = `Camera error: ${
        err.message || "Unknown error occurred"
      }`;
    }
  }
};

// Retry camera initialization
const retryCamera = () => {
  stopCamera();
  initCamera();
};

// Stop camera and scanner
const stopCamera = () => {
  if (intervalId) {
    clearInterval(intervalId);
    intervalId = null;
  }
  if (stream.value) {
    const tracks = stream.value.getTracks();
    tracks.forEach((track) => track.stop());
    stream.value = null;
  }
};

// Use manual input
const useManualInput = () => {
  if (manualInput.value) {
    parseQRData(manualInput.value);
    manualInput.value = "";
    showManualInput.value = false;
  }
};

onMounted(() => {
  fetchSubject();
  window.addEventListener("orientationchange", setVideoOrientation);
});

// Lifecycle hooks
onUnmounted(() => {
  clearData();
  window.removeEventListener("orientationchange", setVideoOrientation);
});
watch(qr_diaglog, (newValue) => {
  if (newValue) {
    initCamera();
  } else {
    stopCamera(); // This is the corrected line
  }
});

const fetchSubject = async () => {
  const authStore = useAuthStore();
  const TOKEN = authStore.getBackendJwt();
  try {
    const response = await axios.get(`/api/subject/subject-list`, {
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        "Content-Type": "application/json",
      },

      validateStatus: function (status) {
        return (
          (status >= 200 && status < 300) ||
          status === 400 ||
          status === 403 ||
          status === 401
        );
      },
    });

    const data = response.data.subject;
    subjectOptions.value = data;
  } catch (err) {
    console.log("error", err);
  }
};

const filteredSubjects = computed(() => {
  if (!subjectPrefix.value) {
    return [];
  }
  return subjectOptions.value.filter(
    (subj) => subj.Subject_Id[3] === subjectPrefix.value
  );
});

const file = ref(null);
const uploadFile = () => {
  if (!file.value) {
    alert("Please select a file first.");
    return;
  }

  const formData = new FormData();
  formData.append("file", file.value);

  axios
    .post("http://your-backend-url/api/upload-csv", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      console.log("Upload successful!", response.data);
      alert("CSV file uploaded and processed successfully!");
      file.value = null; // Reset the file input after successful upload
    })
    .catch((error) => {
      console.error("Error uploading file:", error);
      alert("Error processing file. Check the console for details.");
    });
};
const videoRotationClass = ref("");
const fileupload = async () => {
  if (!file.value) {
    proxy.$swal({
      title: "เกิดข้อผิดพลาด",
      text: ` NO file selected`,
      icon: "error",
      timer: 2000,
      customClass: {
        container: "my-swal-container", // Apply a custom class to the main SweetAlert container
      },
    });
    return;
  }
  try {
    authStore.loading = true;
    const formData = new FormData();
    formData.append("file", file.value);
    formData.append("reqsemester", conCatSemester.value);
    formData.append("reqsubject", subject.value);
    const response = await axios.post(
      `/api/upload-csv`,
      formData,

      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${TOKEN}`,
        },

        validateStatus: function (status) {
          return (
            (status >= 200 && status < 300) ||
            status === 400 ||
            status === 401 ||
            status === 403
          );
        },
      }
    );
    if (response.status === 200 && response.data.lostNum.length === 0) {
      proxy.$swal({
        title: "อัปโหลดสำเร็จ!",
        text: "Upload CSV file successfully!! ",
        icon: "success",
        timer: 2000,
      });
      file.value = null; // Reset the file input after successful upload
      confirmcsv.value = false;
      csvdialog.value = false;
    } else if (response.status === 200 && response.data.lostNum.length > 0) {
      const lostNumbers = response.data.lostNum.join(", ");
      proxy.$swal({
        title: "อัปโหลดสำเร็จบางส่วน",
        html: `ไม่พบรหัสนักศึกษาหมายเลย: <strong>${lostNumbers}</strong>`,
        icon: "warning",
        showConfirmButton: true,

        customClass: {
          container: "my-swal-container", // Apply a custom class to the main SweetAlert container
        },
      });
    } else if (response.status === 400) {
      proxy.$swal({
        title: "เกิดข้อผิดพลาด",
        text: ` ${response.data.message}`,
        icon: "error",
        timer: 2000,
        customClass: {
          container: "my-swal-container", // Apply a custom class to the main SweetAlert container
        },
      });
    } else if (response.status === 401 || response.status === 403) {
      router.push("/");
    } else {
      proxy.$swal({
        title: "เกิดข้อผิดพลาด",
        text: ` An unexpected error occurred.`,
        icon: "error",
        timer: 2000,
        customClass: {
          container: "my-swal-container", // Apply a custom class to the main SweetAlert container
        },
      });
    }
  } catch (error) {
    console.error("Error uploading file:", error);
    alert("Error processing file. Check the console for details.");
  } finally {
    authStore.loading = false;
  }
};
const setVideoOrientation = () => {
  if (window.screen.orientation) {
    const orientation = window.screen.orientation.type;
    // On many tablets in landscape, the camera stream is still portrait,
    // so we need to rotate it 90 degrees to appear correct.
    if (orientation.startsWith("landscape")) {
      // You may need to try 'rotate-90' or 'rotate--90' depending on device
      videoRotationClass.value = "rotate-90";
    } else {
      // In portrait, reset the rotation
      videoRotationClass.value = "";
    }
  } else {
    // Fallback for older browsers or inconsistent devices.
    // We can check the aspect ratio of the window
    if (window.innerWidth > window.innerHeight) {
      videoRotationClass.value = "rotate-90";
    } else {
      videoRotationClass.value = "";
    }
  }
};
</script>

<style scoped>
.qr-scanner-video {
  width: 100%;
  height: auto;
  border-radius: 8px;
  background-color: #000;
  max-height: 300px;
  object-fit: cover;
  transform: rotate(90deg) scale(1.5);
}

.v-alert ul {
  margin-top: 8px;
  padding-left: 20px;
}
.rotate-90 {
  transform: rotate(0deg);

  object-fit: cover;
}
.video-container {
  /* Set a fixed aspect ratio and hide overflow */

  position: relative;
  overflow: hidden;
}
</style>
<style>
.v-messages .v-messages__message {
  color: red;
}
</style>
